import React from 'react';
import FullScreenAgencySelector from 'wb-spotify/app/routes/superGrid/tool/advertiserOAuth/fullScreenAgencySelector';
import { Button, PlusIcon, useOpen } from '@aleph/shared-components';
import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const SpotifyAdvertiserOAuth = () => {
	const { t } = useTranslation();
	const [agencySelectorOpen, { onOpen, onClose }] = useOpen(false);

	const redirectToOAuth = (advertiserAccountId: string) => {
		const oauthState = btoa(JSON.stringify({
			state: JSON.stringify({
				network: 'pn_sp',
				app:     'user',
				advertiserAccountId,
			}),
			redirectUri: `https://${window.location.host}/OAuth`,
		}));
		window.location.href = `${import.meta.env.VITE_API_PATH}/oauth/spotify/redirect/pn_sp?state=${oauthState}&app=spotify`;
	};

	return (
		<>
			<AnimatePresence>
				<FullScreenAgencySelector
					onAgencySelected={redirectToOAuth}
					onClose={onClose}
					isOpen={agencySelectorOpen}
				/>
			</AnimatePresence>

			<div className="flex h-[32px] w-[74px] items-center justify-center">
				<Button
					title={t('sc: new')}
					onClick={onOpen}
					leftNode={<PlusIcon width={16} />}
					className="!pl-[6px] ml-[2px]"
					data-testid="add-new-entity-button"
				/>
			</div>
		</>
	);
};

export default SpotifyAdvertiserOAuth;
